import classNames from 'classnames'
import React, { HTMLAttributes } from 'react'
import { InputType } from 'reactstrap/lib/Input'
import styled from 'styled-components/macro'
import { COLORS } from '../../src/styles/colors'

interface IEvixInlineInputTextProps {
  style?: object
  id?: string
  type?: InputType
  error?: boolean
  success?: boolean
  disabled?: boolean
  placeholder?: string
  value?: string
  onChangeRaw?: (e: React.FormEvent<HTMLInputElement>) => void
  onChange?: (data: any) => void
  onEnter?: () => void
  guideText?: string
  inputProps?: HTMLAttributes<HTMLInputElement>
  title?: string
  maxLength?: number
  onClick?: () => void
  readOnly?: boolean
}

export const EvixInlineInputText: React.FC<IEvixInlineInputTextProps> = props => {
  const {
    style,
    id,
    placeholder,
    value,
    onChangeRaw,
    onChange,
    onEnter,
    onClick,
    guideText,
    type,
    title,
    readOnly,
    maxLength,
    inputProps = {},
    ...cnProps
  } = props
  const cn = classNames('od-input', cnProps)
  const cnWrapper = classNames('od-input-wrapper', {
    success: cnProps.success,
    error: cnProps.error,
    disabled: cnProps.disabled,
  })

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    onChangeRaw?.(e)
    // @ts-ignore
    onChange?.(e.target.value)
  }

  const handleKeydown = (e: any) => {
    if (e.key === 'Enter') {
      onEnter?.()
      e.preventDefault()
    }
  }

  return (
    <div style={style}>
      <InputWrap className={cnWrapper}>
        <input
          type={type}
          style={value ? undefined : placeholderCss}
          id={id}
          disabled={cnProps.disabled}
          className={cn}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onKeyPress={handleKeydown}
          {...inputProps}
          title={title}
          maxLength={maxLength}
          onClick={onClick}
          readOnly={readOnly}
        />
      </InputWrap>
    </div>
  )
}

const InputWrap = styled.div`
  .od-input {
    height: 42px;
    font-size: 15px;
    font-weight: 500;
    background-color: ${COLORS.GRAYEE};
    border-radius: 4px;
  }
`

const placeholderCss = { fontSize: 13, color: '#ababab !important' }
